exports["flintapp-positiverelating-internals"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	
	  var packages = {}
	
	    packages["config"] = __webpack_require__(1);
	  packages["data"] = __webpack_require__(2);
	  packages["records"] = __webpack_require__(5);
	  packages["mframework/util"] = __webpack_require__(6);
	
	
	  window.require.setApp("flintapp-positiverelating")
	  module.exports = packages
	  

/***/ },
/* 1 */
/***/ function(module, exports) {

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var isLive = document.location.href.indexOf("local") == -1;
	
	exports.default = {
	  apiBaseUrl: isLive ? 'https://positiverelating-api.herokuapp.com/' : 'http://localhost:5000/',
	  firebaseAppName: 'positiverelating',
	  imgixPrefix: 'https://positiverelating.imgix.net/',
	  mixpanelToken: 'a1e94772a85dce72465f72070f00a40d',
	  s3Bucket: 'positiverelating',
	  s3UrlPrefix: 'https://positiverelating.s3.amazonaws.com/'
	};
	module.exports = exports.default;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var _interopRequireDefault = __webpack_require__(3).default;
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _immutable = __webpack_require__(4);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	exports.default = {
	  girlsGameEpisodes: _immutable2.default.List([{
	    season: 1,
	    episode: 1,
	    title: "The Subtext of Texting",
	    url: 'http://screen.yahoo.com/subtext-texting-050000619.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/0ywpA896kYqxlJz__jpY.Q--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/filename.jpg'
	  }, {
	    season: 1,
	    episode: 2,
	    title: "Avoiding his Friend Zone",
	    url: 'http://screen.yahoo.com/avoiding-friend-zone-005700731.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/kl0mhuQHST4AYJev97jUKA--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/sarah-bg-smaller_fix.jpg'
	  }, {
	    season: 1,
	    episode: 3,
	    title: "How to Spot a Player",
	    url: 'http://screen.yahoo.com/spot-player-140000332.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/iHRUBgB98eEV5f7i9CjrwA--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/lisa-thumb3.jpg'
	  }, {
	    season: 1,
	    episode: 4,
	    title: "Avoid a Dating Disaster",
	    url: 'http://screen.yahoo.com/avoid-disaster-date-100000557.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/9ViDdZ31N.9RFleu6T5R8w--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/danyella-thumb.jpg'
	  }, {
	    season: 1,
	    episode: 5,
	    title: "How to Screen Out Online Creeps",
	    url: 'http://screen.yahoo.com/spot-online-creep-150000798.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/0DznVRBLnOlEEDcWHCbxfQ--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/liz_thumb8.jpg'
	  }, {
	    season: 1,
	    episode: 6,
	    title: "How to Get a Guy to Approach You",
	    url: 'http://screen.yahoo.com/him-approach-153000702.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/0DznVRBLnOlEEDcWHCbxfQ--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/liz_thumb8.jpg'
	  }, {
	    season: 1,
	    episode: 7,
	    title: "How to Approach a Guy",
	    url: 'http://screen.yahoo.com/approach-guy-150000766.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/kq.L85gBue.KjuKUVoRVYA--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/kenzie-still-1.jpg'
	  }, {
	    season: 1,
	    episode: 8,
	    title: "How to Kill Boring Conversation",
	    url: 'http://screen.yahoo.com/kill-boring-conversation-033000553.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/UWrSIsV_vCzdYgqx8dnvKg--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/jackie-thumb_fix.jpg'
	  }, {
	    season: 1,
	    episode: 9,
	    title: "Pick Up Tips for Tall Girls",
	    url: 'http://screen.yahoo.com/pick-tips-tall-girls-183000254.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/cjTCndX3NOGTC71jGMw25Q--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/millie-thumb.jpg'
	  }, {
	    season: 1,
	    episode: 10,
	    title: "How to do Sexual Innuendo",
	    url: 'http://screen.yahoo.com/sexual-innuendo-210000209.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/wALisU6kxCnG5Ncuvl.gnA--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/denise-thumb.jpg'
	  }, {
	    season: 1,
	    episode: 11,
	    title: "How to Reject a Guy",
	    url: 'http://screen.yahoo.com/reject-guy-161000309.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/kfxBbPJsJdjizdlgC7xTIQ--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/rejection-thumb_fix2.jpg'
	  }, {
	    season: 1,
	    episode: 12,
	    title: "Find His Inner Bad Boy",
	    url: 'http://screen.yahoo.com/inner-bad-boy-220000829.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/fdYdwVjmrfPZk75EccZGWQ--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/en-US/video/video.thegirlsgame.com/jake-still2a.jpg'
	  }, {
	    season: 2,
	    episode: 1,
	    title: "The Produce Pickup",
	    url: 'https://screen.yahoo.com/produce-pickup-man-groceries-230842825.html',
	    thumbUrl: 'https://s.yimg.com/uu/api/res/1.2/kuLJIy6p_i8Qeyp0KF0eEQ--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/video/keyframes//girlsgame/lotus/f06f2c1e-52a4-415c-931a-caa5097d5630_MJam_0suC8Jkbqd_iO2gOSVUp-f_hNYBuD1SHMB0eqYTnhLGrOEKkbAOIxXbqLhaBQ1Ee4vKmg8-_17_129.jpg'
	  }, {
	    season: 2,
	    episode: 2,
	    title: "Weeding Out Bad Apples",
	    url: 'https://screen.yahoo.com/produce-pickup-weeding-bad-apples-070100732.html',
	    thumbUrl: 'https://s.yimg.com/uu/api/res/1.2/kuLJIy6p_i8Qeyp0KF0eEQ--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://media.zenfs.com/video/keyframes//girlsgame/lotus/f06f2c1e-52a4-415c-931a-caa5097d5630_MJam_0suC8Jkbqd_iO2gOSVUp-f_hNYBuD1SHMB0eqYTnhLGrOEKkbAOIxXbqLhaBQ1Ee4vKmg8-_17_129.jpg'
	  }, {
	    season: 2,
	    episode: 3,
	    title: "Ageless Attraction - Emotion-Spiking Tips for Every Woman",
	    url: 'https://screen.yahoo.com/ageless-attraction-emotion-spiking-tips-070000242.html',
	    thumbUrl: 'https://s.yimg.com/uu/api/res/1.2/t2oVfIVovnicEvAO.KsBvg--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://d.yimg.com/hd/girlsgame/lotus/ea0c682d-290f-4758-aab0-cbebc220228a_-uBHA6klCpf-DAWU0CmrBm2MOWkRz-gcfIOiFjQ5GAU5anWuA3OsNL6nLoAmpdwQTzp_e-BH1LY-_2_0.jpg?s=411ab60111a013ece98b5fd53224a371&c=8955ed7ce7f28cc731c46357d9fb7de6&a=girlsgame&mr=0'
	  }, {
	    season: 2,
	    episode: 4,
	    title: "Sprucing Up a Boring Coffee Date",
	    url: 'https://screen.yahoo.com/sprucing-boring-coffee-date-070000204.html',
	    thumbUrl: 'https://s.yimg.com/uu/api/res/1.2/t2oVfIVovnicEvAO.KsBvg--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://d.yimg.com/hd/girlsgame/lotus/ea0c682d-290f-4758-aab0-cbebc220228a_-uBHA6klCpf-DAWU0CmrBm2MOWkRz-gcfIOiFjQ5GAU5anWuA3OsNL6nLoAmpdwQTzp_e-BH1LY-_2_0.jpg?s=411ab60111a013ece98b5fd53224a371&c=8955ed7ce7f28cc731c46357d9fb7de6&a=girlsgame&mr=0'
	  }, {
	    season: 2,
	    episode: 5,
	    title: "Creating Chemistry: How to Make Him Fall for your Personality",
	    url: 'https://screen.yahoo.com/creating-chemistry-him-fall-personality-070000900.html',
	    thumbUrl: 'https://s.yimg.com/uu/api/res/1.2/nowd2MDZbZP96kfTzXvKcg--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://d.yimg.com/hd/girlsgame/lotus/ca49325c-2709-4115-ae6f-a9b7727a08c5_Tfcc5p8vWJU-waryTfbF6n6renbl71Up1xKdm3fW4HCndAfY97JSol81IR2I-vP8wiNKSff0Uac-_2_0.jpg?s=fb434749d8c823c83223a6982f98dd93&c=2440032d366f37af157e0e23d3db610d&a=girlsgame&mr=0'
	  }, {
	    season: 2,
	    episode: 6,
	    title: "Golfing with Gola",
	    url: 'https://screen.yahoo.com/golfing-gola-070000919.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/.f7Z9MbdB7Lbp_8xgKpuvA--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://d.yimg.com/hd/girlsgame/lotus/47202807-37c5-4b48-9a46-818ab527c660_6ZMQ8ashXMUcHHeym5QlhtfgKYTl9dATW0aVtmFRe4Cr4QCGQabryWyzsdz5UNa5yl2zFzivPAk-_2_0.jpg?s=aeb4964e243525dfd4979701b2ae5192&c=dd980a702a8af1d456ef5aa3a878cc34&a=girlsgame&mr=0'
	  }, {
	    season: 2,
	    episode: 7,
	    title: "Bringing Out His Alpha",
	    url: 'https://screen.yahoo.com/bringing-alpha-male-070000318.html',
	    thumbUrl: 'https://s1.yimg.com/uu/api/res/1.2/s0ozjsSB8Kz8XZi6g27KZA--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://d.yimg.com/hd/girlsgame/lotus/4c2bc941-ba0d-4ad8-af97-727c5be7125f_kiQKROJzX8B6opTW6P8ltH_kcCIZwFJzMS-7B9sytjdPb1gGgH80Zjpkvry68Eo8_akjgo52E4A-_2_0.jpg?s=c8b2868c74c60e1b8b1d9f373dece328&c=947bd6bd003724cd2f19ad0a3574c6b3&a=girlsgame&mr=0'
	  }, {
	    season: 2,
	    episode: 8,
	    title: "Testing your Date - When is Enough, Enough?",
	    url: 'https://screen.yahoo.com/testing-date-enough-enough-070000038.html',
	    thumbUrl: 'https://s.yimg.com/uu/api/res/1.2/WW1DaNkItQYHBdURaxv21Q--/Zmk9ZmlsbDtweW9mZj0wO3c9NjQwO2g9MzYwO3NtPTE7YXBwaWQ9eXRhY2h5b24-/http://d.yimg.com/hd/girlsgame/lotus/b4abfb98-9e70-4872-9496-1c62f9afa465_0j9K1-x2CpE_Tfzylm-sCkZiNuFSDqkWGr4l17_KigfeG12ZahyUy9jfqsQuYZQspgiNKfwXsRk-_2_0.jpg?s=4e8e046bab2f8a92bce82c17b4a9c89e&c=61c6cf80404960536231279e6c9d7c28&a=girlsgame&mr=0'
	  }]),
	
	  textingTipsPosts: _immutable2.default.List([{
	    title: 'Convo #11: Role play teasing with high value velocity and sexual frame',
	    timestamp: new Date('2015-10-13'),
	    url: '/convo-11-role-play-teasing-with-high-value-velocity-and-sexual-frame',
	    thumbUrl: 'https://i.imgur.com/PSXRM4Z.png'
	  }, {
	    title: 'Convo #10: Two kinds of teases',
	    timestamp: new Date('2015-10-13'),
	    url: '/convo-10-two-kinds-of-teases',
	    thumbUrl: 'https://i.imgur.com/JR0edOb.png'
	  }, {
	    title: 'Convo #9: Discussing party logistics with high-value-velocity teasing and sexual frame',
	    timestamp: new Date('2015-10-12'),
	    url: '/convo-9-discussing-party-logistics-with-high-value-velocity-teasing-and-sexual-frame',
	    thumbUrl: 'https://i.imgur.com/uli2iMo.png'
	  }, {
	    title: 'Value Velocity: Make every word count',
	    timestamp: new Date('2015-10-11'),
	    url: '/value-velocity-make-every-word-count',
	    thumbUrl: 'https://i.imgur.com/TO9m3CF.png'
	  }])
	};
	module.exports = exports.default;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = require("babel-runtime/helpers/interop-require-default");

/***/ },
/* 4 */
/***/ function(module, exports) {

	module.exports = require("immutable");

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _immutable = __webpack_require__(4);
	
	exports.default = {
	  ResiApp: (0, _immutable.Record)({
	    gender: null,
	    firstName: null,
	    lastName: null,
	    city: null,
	    state: null,
	    phone: null,
	    email: null,
	    freeTime: null,
	    anxiety: null,
	    whyInterested: null,
	    wouldTravel: null,
	    formalTraining: null,
	    howMuchWorth: null
	  })
	};
	module.exports = exports.default;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var _interopRequireDefault = __webpack_require__(3).default;
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	exports.default = {
	  alertError: function alertError(err) {
	    // TODO: Show a modal dialogue
	    // alert(err.message)
	    console.error(err);
	  },
	
	  compare: function compare(a, b) {
	    return M.util.makeComparator(function (x) {
	      if (x instanceof String) {
	        return x.toUpperCase();
	      } else {
	        return x;
	      }
	    })(a, b);
	  },
	
	  formatMessengerDate: function formatMessengerDate(date) {
	    date = (0, _moment2.default)(date);
	    var now = (0, _moment2.default)();
	
	    if (now.diff(date, 'days') < 1) {
	      return date.format('h:mma');
	    } else if (now.diff(date, 'weeks') < 1) {
	      return date.format('ddd');
	    } else {
	      return date.format('MMM D');
	    }
	  },
	
	  makeComparator: function makeComparator(keyFunc) {
	    var reverse = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	    return function (a, b) {
	      if (reverse) {
	        var _ref = [b, a];
	        a = _ref[0];
	        b = _ref[1];
	      }
	      var aKey = keyFunc(a);
	      var bKey = keyFunc(b);
	
	      if (aKey < bKey) {
	        return -1;
	      } else if (bKey < aKey) {
	        return 1;
	      } else {
	        return 0;
	      }
	    };
	  },
	
	  makeSlug: function makeSlug(str) {
	    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
	  },
	
	  makeUrl: function makeUrl(pathParams, queryParams) {
	    var url = '/' + (pathParams || []).join('/');
	    var queryParamsStr = M.util.objToParamString(queryParams);
	    if (queryParamsStr) {
	      url += '?' + queryParamsStr;
	    }
	    return url;
	  },
	
	  mod: function mod(a, b) {
	    // Like a % b but behaves properly when a is negative
	    return (a % b + b) % b;
	  },
	
	  objToParamString: function objToParamString(obj) {
	    var str = "";
	    for (var key in obj) {
	      if (obj[key] == null) continue;
	
	      if (str != "") {
	        str += "&";
	      }
	      str += key + "=" + encodeURIComponent(obj[key]);
	    }
	    return str;
	  },
	
	  shuffle: function shuffle(arr) {
	    // http://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array-in-javascript
	    var stackOverflowShuffleFunc = function shuffle(o) {
	      for (var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
	      return o;
	    };
	    stackOverflowShuffleFunc(arr);
	  },
	
	  urlRegex: /((?:https?:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b(?:[-a-zA-Z0-9@:%_\+.~#?&//=]*))/
	};
	module.exports = exports.default;

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = require("moment");

/***/ }
/******/ ]);
//# sourceMappingURL=internals.js.map